import { render, staticRenderFns } from "./CruiseDetailVrLink.vue?vue&type=template&id=22942eb0&scoped=true"
import script from "./CruiseDetailVrLink.vue?vue&type=script&lang=js"
export * from "./CruiseDetailVrLink.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailVrLink.vue?vue&type=style&index=0&id=22942eb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22942eb0",
  null
  
)

export default component.exports